module.exports = __webpack_public_path__ + "img/embed.1b3ee0ec.png";